import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyConceptDeterminationMethods } from './useConceptDeterminationMethods';
import { getQueryKey as getQueryKeyConceptDeterminationMethodById } from './useConceptDeterminationMethodById';

// Config
import { uiConfig } from '../../../conf/conceptDeterminationMethods';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CONCEPT_DETERMINATION_METHOD);

export const useCreateConceptDeterminationMethod = ({
    crudConfig,
    sessionToken,
    onSuccessCb,
    onErrorCb,
    onSettledCb
}) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newMethod }) => Client.insert(sessionToken, newMethod),
        onSuccess: (data, variables) => {
            updateCacheArray({
                queryKey: getQueryKeyConceptDeterminationMethods(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeyConceptDeterminationMethodById(data.codeId)
            });
            onSuccessCb?.({ data: data.codeId, context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
